import React from 'react';
import './App.css';
import App from './App';

import { render } from 'react-dom';
render(<App />, document.getElementById('root'));
